import moment from 'moment';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useReferralHistoryContext } from '../../../contexts/ReferralHistoryProvider';
import useAppointmentRequestActions from '../../../hooks/APIHooks/appointments/useAppointmentRequestActions';
import { AssociateReferral, Referral } from '../../../types/referral';
import { User } from '../../../types/users';
import { showTimeIn12HrsFormat } from '../../../utils/timeAndDate';
import AcademiaSectionWrapper from '../AcademiaSectionWrapper';
import SkillBadge from '../Badges/SkillBadge';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ReferralDetailsModal = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();
  const { referralHistoryType, referral } = useReferralHistoryContext();

  // destructuring the referral object here
  const { appointment_request, client_full_name, reason } =
    (referral as Referral) || {};

  // integration of custom API hooks here
  const { getAppointmentReqById } = useAppointmentRequestActions(
    '',
    appointment_request
  );

  console.log('APPOINTMENT DETAILS: ', getAppointmentReqById.data?.data);

  // rendering referral details modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='Referral details' />

      {getAppointmentReqById.isSuccess ? (
        <div>
          <AcademiaSectionWrapper sectionTitle='Appointment Details'>
            <div className='grid grid-cols-[150px_10px_1fr] text-base-purple'>
              <p>Client Name</p>
              <p>:</p>
              <p className='font-medium'>{client_full_name}</p>

              <p>Associate Name</p>
              <p>:</p>
              <p className='font-medium'>
                {getAppointmentReqById.data.data.associate_full_name}
              </p>
            </div>

            <div className='grid grid-cols-[150px_10px_1fr] text-base-dark-green text-sm mt-2'>
              <p>Appointment Date</p>
              <p>:</p>
              <p className='font-medium'>
                {moment(getAppointmentReqById.data.data.date).format(
                  'DD-MM-YYYY'
                )}
              </p>

              <p>Appointment Time</p>
              <p>:</p>
              <p className='font-medium'>
                {`${showTimeIn12HrsFormat(
                  getAppointmentReqById.data.data.start_time
                )} - ${showTimeIn12HrsFormat(
                  getAppointmentReqById.data.data.end_time
                )}`}
              </p>
            </div>

            <div className='grid grid-cols-[150px_10px_1fr] text-base-light-blue text-sm mt-2'>
              <p>Appointment Service</p>
              <p>:</p>
              <p className='font-medium'>
                {getAppointmentReqById.data.data.service_name}
              </p>
            </div>
          </AcademiaSectionWrapper>
          {(currentUser as User)?.role_name === 'Admin' ? (
            <AcademiaSectionWrapper sectionTitle='Referred Associates'>
              <div className='flex flex-wrap gap-2'>
                {(referral as Referral).referred_to_full_name.map(
                  (name, index) => (
                    <SkillBadge key={index} badgeLabel={name} color='#388229' />
                  )
                )}
              </div>
            </AcademiaSectionWrapper>
          ) : null}

          {referralHistoryType === 'to' ? (
            <AcademiaSectionWrapper sectionTitle='Referred Associates'>
              <div className='flex flex-wrap gap-2'>
                {(referral as AssociateReferral).referred_to_full_names.map(
                  (name, index) => (
                    <SkillBadge key={index} badgeLabel={name} color='#388229' />
                  )
                )}
              </div>
            </AcademiaSectionWrapper>
          ) : null}

          <AcademiaSectionWrapper sectionTitle='Reason of Referral'>
            <p className='text-base-dark-blue'>{reason}</p>
          </AcademiaSectionWrapper>
        </div>
      ) : null}
    </ParentModal>
  );
};

export default ReferralDetailsModal;
